import numeral from 'numeral'
import moment from 'moment'
import josa from 'josa-js'

export default {
  methods: {
    getToday () {
      return new Date().toJSON().slice(0, 10).replace(/-/g, '-')
    },
    getScreenHeight (calHeight = 0) {
      const windowHeight = window.innerHeight
      const searchBoxHeight = this.$refs.searchBox ? this.$refs.searchBox.clientHeight : 150
      const headerBoxHeight = 60
      const marginHeight = 100
      // console.log(windowHeight - searchBoxHeight - headerBoxHeight - marginHeight - calHeight)
      return windowHeight - searchBoxHeight - headerBoxHeight - marginHeight - calHeight
    },
    getOnlyNumber (value) {
      return value.replace(/[^\d]/g, '')
    },
    isEmpty (value) {
      if (value === '' || value === null || value === undefined || (value !== null && typeof value === 'object' && !Object.keys(value).length)) {
        return true
      } else {
        return false
      }
    },
    isEmptySeq (value) {
      if (value === '' || value === null || value === undefined || value === 0 || value === '0' || (value !== null && typeof value === 'object' && !Object.keys(value).length)) {
        return true
      } else {
        return false
      }
    },
    columnFormatterDate (row, column) {
      return this.formatterDate(row[column.property])
    },
    columnFormatterNumber (row, column) {
      return this.formatterNumber(row[column.property])
    },
    columnFormatterPrecision (row, column) {
      return this.formatterPrecision(row[column.property])
    },
    columnFormatterRate (row, column) {
      return this.formatterRate(row[column.property])
    },
    columnFormatterPhone (row, column) {
      return this.formatterPhone(row[column.property])
    },
    formatterDate (value, formatString = 'YYYY.MM.DD') {
      if (value === '-') {
        return value
      }
      return value ? moment(value).format(formatString) : ''
    },
    formatterDateTime (value, format1 = 'YYYY.MM.DD HH:mm:ss', format2 = 'YYYYMMDDHHmmss') {
      return value ? moment(value, format2).format(format1) : ''
    },
    formatterNumber (value) {
      return this.formatterNumeral(value, '0,0')
    },
    formatterPrecision (value) {
      return this.formatterNumeral(value, '0,0.0')
    },
    formatterRate (value) {
      return this.formatterNumeral(value, '0.0') + '%'
    },
    formatterNumeral (value, formatString) {
      return numeral(value).format(formatString)
    },
    toNumber (value) {
      return numeral(value)
    },
    downloadFile (url) {
      window.location.assign(url)
    },
    replaceCarriageReturnToBr (value) {
      return value ? value.replace(/(?:\r\n|\r|\n)/g, '<br />') : ''
    },
    replaceJosa (value, format) {
      return josa.r(value, format)
    },
    searchJosa (value, format) {
      return josa.c(value, format)
    },
    getWeekStartDate (value) {
      return moment().day(value).format('YYYYMMDD')
    },
    getWeekStartDate2 (value) {
      return moment().day(value).toDate()
    },
    getWeekStartDateNew (value, day) {
      if (value) {
        return moment(value).day(day).format('YYYYMMDD')
      } else {
        return moment().day(day).format('YYYYMMDD')
      }
    },
    getMonthLastDay (value) {
      return parseInt(moment(value, 'YYYYMM').endOf('month').format('DD'), 10)
    },
    formatterPhone (value, type = 1) {
      if (!value) {
        return ''
      }
      let result = ''
      if (value.length === 11) {
        result = value.replace(/(\d{3})(\d{4})(\d|\*{4})/, type === 0 ? '$1-****-$3' : '$1-$2-$3')
      } else if (value.length === 8) {
        result = value.replace(/(\d{4})(\d{4})/, '$1-$2')
      } else {
        if (value.indexOf('02') === 0) {
          result = value.replace(/(\d{2})(\d{3,4})(\d{4})/, type === 0 ? '$1-****-$3' : '$1-$2-$3')
        } else {
          result = value.replace(/(\d{3})(\d{3})(\d|\*{4})/, type === 0 ? '$1-***-$3' : '$1-$2-$3')
        }
      }
      return result
    },
    getToNumber (value) {
      return value ? parseInt(value, 10) : 0
    },
    addMomentDay (value, type = 'days') {
      return moment().add(value, type).format('YYYYMMDD')
    },
    addDays (value, addDay) {
      return moment(value).add(addDay, 'days').format('YYYYMMDD')
    },
    getDates (startDate, endDate) {
      const dateArray = []
      var currentDate = moment(startDate)
      var stopDate = moment(endDate)
      while (currentDate <= stopDate) {
        dateArray.push(moment(currentDate).format('YYYYMMDD'))
        currentDate = moment(currentDate).add(1, 'days')
      }
      return dateArray
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/common-func.js